import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function TrustedSellersArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-trusted-sellers"]} />;
}